/* Darlida add-to-cart page flow. Adds without clearing the bag; confirms every requested line before leaving. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var C = window.D4Checkout = { busy: false };
  var marker = 'd4-checkout-return';
  function createDrawerFeedback() {
    var controls = [], held = [], started = 0, pending = false, failed = false, dismissed = false;
    var ar = document.documentElement.lang.indexOf('ar') === 0;
    function host() { return document.querySelector('cart-drawer'); }
    function release() {
      controls.forEach(function (x) { if (x.el.isConnected) x.el.disabled = x.disabled; }); controls = [];
      held.forEach(function (x) { if (x.el.isConnected) x.el.inert = x.inert; }); held = [];
    }
    function lock() {
      var drawer = host(); if (!drawer) return;
      drawer.querySelectorAll('cart-drawer-items, .cart-drawer__footer').forEach(function (el) { held.push({ el: el, inert: el.inert }); el.inert = true; });
      drawer.querySelectorAll('[name="checkout"]').forEach(function (el) { controls.push({ el: el, disabled: el.disabled }); el.disabled = true; });
      drawer.setAttribute('aria-busy', 'true'); drawer.setAttribute('data-cart-pending', 'true');
    }
    function begin() {
      if (pending) return;
      release(); pending = true; failed = false; dismissed = false; started = Date.now();
      var drawer = host(); if (drawer) drawer.querySelectorAll('.cart-speed-state').forEach(function (el) { el.remove(); });
      lock();
    }
    function done() {
      var drawer = host(); release(); pending = false; failed = false;
      if (drawer) { drawer.querySelectorAll('.cart-speed-state').forEach(function (el) { el.remove(); }); drawer.removeAttribute('data-cart-pending'); drawer.removeAttribute('aria-busy'); drawer.dataset.cartReadyMs = String(Date.now() - started); }
    }
    function error() {
      release(); pending = false; failed = true; lock();
      var drawer = host(), inner = drawer && drawer.querySelector('.drawer__inner'); if (!inner) return;
      drawer.setAttribute('aria-busy', 'false');
      inner.querySelectorAll('.cart-speed-state').forEach(function (el) { el.remove(); });
      var box = document.createElement('div'); box.className = 'cart-speed-state'; box.setAttribute('role', 'alert');
      var text = document.createElement('p'); text.textContent = ar ? 'لم نقدر نأكد السلة. راجعيها قبل إتمام الطلب.' : 'We could not confirm your cart. Please review it before checkout.';
      var link = document.createElement('a'); link.href = (window.Shopify && Shopify.routes.root || '/') + 'cart'; link.textContent = ar ? 'راجعي السلة' : 'Review your cart';
      box.appendChild(text); box.appendChild(link); inner.insertBefore(box, inner.firstChild);
      if (!dismissed && !drawer.classList.contains('active')) drawer.open(document.activeElement);
    }
    function block(e) {
      if (!pending && !failed) return;
      var target = e.target;
      if (target.closest && target.closest('.drawer__close, #CartDrawer-Overlay')) dismissed = true;
      if ((e.type === 'submit' && target.closest && target.closest('cart-drawer')) || (target.closest && target.closest('cart-drawer [name="checkout"], cart-drawer a[href*="/checkout"], cart-drawer .additional-checkout-buttons, cart-drawer shopify-accelerated-checkout-cart'))) { e.preventDefault(); e.stopImmediatePropagation(); }
    }
    document.addEventListener('click', block, true); document.addEventListener('submit', block, true);
    document.addEventListener('keydown', function (e) { if (pending && e.key === 'Escape') dismissed = true; }, true);
    var style = document.createElement('style');
    style.textContent = '.cart-speed-state{padding:12px 18px;border-bottom:1px solid currentColor;font-size:14px;line-height:1.5}.cart-speed-state a{color:inherit;text-decoration:underline}'; document.head.appendChild(style);
    return { begin: begin, done: done, error: error, active: function () { return pending || failed; }, shouldOpen: function () { return !dismissed; } };
  }
  var drawerFeedback = createDrawerFeedback();

  function request(path, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return window.fetch(root + path, opts).then(function (r) { return r.json().then(function (d) {
      if (!r.ok || d.status >= 400) throw new Error(d.description || d.message || 'We could not confirm your items.');
      return d;
    }); });
  }
  function properties(p) { var out = {}; Object.keys(p || {}).sort().forEach(function (k) { if (p[k] !== '' && p[k] != null) out[k] = String(p[k]); }); return JSON.stringify(out); }
  function matches(line, item) {
    var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id;
    return String(line.variant_id || line.id) === String(item.id) && properties(line.properties) === properties(item.properties) && String(plan || '') === String(item.selling_plan || '');
  }
  function count(cart, item) { return (cart.items || []).reduce(function (n, line) { return n + (matches(line, item) ? line.quantity : 0); }, 0); }
  function aggregate(items) { var result = []; items.forEach(function (item) { var found = result.filter(function (x) { return String(x.id) === String(item.id) && properties(x.properties) === properties(item.properties) && String(x.selling_plan || '') === String(item.selling_plan || ''); })[0]; if (found) found.quantity += Number(item.quantity); else result.push(Object.assign({}, item, { quantity: Number(item.quantity) })); }); return result; }
  C.renderDrawer = function (sections) {
    var drawer = document.querySelector('cart-drawer');
    var source = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var inner = drawer && drawer.querySelector('.drawer__inner'), next = source.querySelector('#CartDrawer .drawer__inner');
    var bubble = document.getElementById('cart-icon-bubble');
    var nextBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    if (!inner || !next || !bubble || !nextBubble) throw new Error('Drawer sections incomplete');
    inner.innerHTML = next.innerHTML;
    inner.classList.toggle('is-empty', next.classList.contains('is-empty'));
    drawer.classList.toggle('is-empty', !!next.querySelector('.drawer__inner-empty'));
    bubble.innerHTML = nextBubble.innerHTML;
  };
  function openDrawer(cart) {
    var drawer = document.querySelector('cart-drawer'), trigger = document.activeElement;
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.open !== 'function') return Promise.reject(new Error('Drawer unavailable'));
    return (cart.sections && cart.sections['cart-drawer'] && cart.sections['cart-icon-bubble'] ? Promise.resolve(cart.sections) : window.fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Drawer refresh failed');
      return response.json();
    })).then(function (sections) {
      if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('Drawer sections incomplete');
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger);
      C.renderDrawer(sections);
      drawerFeedback.done();
      if (drawerFeedback.shouldOpen() && !drawer.classList.contains('active')) drawer.open(trigger);
      document.querySelectorAll('#cart-icon-bubble, .header__icon--cart, [data-d4-cart]').forEach(function (bag) { bag.setAttribute('aria-label', 'Shopping bag, ' + cart.item_count + ' items. Review or edit your bag'); });
    });
  }
  function finishAdd() {
    C.busy = false;
    if (window.D4Gift && window.D4Gift.resume) window.D4Gift.resume(true);
    document.querySelectorAll('form[data-d4-checkout-pending="true"]').forEach(function (form) {
      form.dataset.d4CheckoutPending = 'false';
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = false;
    });
    document.querySelectorAll('[data-d4-atc].is-loading').forEach(function (button) { button.disabled = false; button.classList.remove('is-loading'); });
  }
  C.add = function (body, options) {
    if (C.busy) return Promise.reject(new Error('Your bag is already being updated.'));
    C.busy = true; drawerFeedback.begin();
    var attempted = false, before, items = aggregate(body.items || []), gift = window.D4Gift;
    var replaceClock = !!(options && options.replaceClockBundle && items.length === 1 && String(items[0].id) === '45970632999148' && [1, 3, 5].indexOf(items[0].quantity) !== -1);
    var giftIdle = gift && gift.pause ? gift.pause() : Promise.resolve();
    return Promise.resolve(giftIdle).then(function () { return request('cart.js'); }).then(function (cart) {
      before = cart;
      if (gift && gift.bundleSelected && options && options.physical && (!replaceClock || count(cart, items[0]) !== items[0].quantity)) gift.bundleSelected(options.bundleQuantity);
      if (!items.length || items.some(function (i) { return !i.id || !Number.isInteger(i.quantity) || i.quantity < 1; })) throw new Error('Please check your selected items and quantities.');
      var existing = replaceClock ? (cart.items || []).filter(function (line) { return matches(line, items[0]); }) : [];
      if (existing.length) {
        if (count(cart, items[0]) === items[0].quantity) return cart;
        var updates = {};
        existing.forEach(function (line, index) { updates[line.key] = index === 0 ? items[0].quantity : 0; });
        attempted = true;
        return request('cart/update.js', { updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname });
      }
      attempted = true;
      return request('cart/add.js', Object.assign({}, body, { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }));
    }).then(function (added) {
      return gift && gift.syncForCheckout ? gift.syncForCheckout(added.sections) : request('cart.js').then(function (cart) { cart.sections = added.sections; return cart; });
    }).then(function (cart) {
      if (items.some(function (item) { return replaceClock ? count(cart, item) !== item.quantity : count(cart, item) < count(before, item) + item.quantity; })) throw new Error('Not all selected items could be confirmed.');
      return openDrawer(cart).then(function () { finishAdd(); return cart; });
    }).catch(function (err) {
      err.addAttempted = attempted; C.busy = false; drawerFeedback.error();
      if (gift && gift.resume) gift.resume();
      throw err;
    });
  };

  /* Simple collection quick-add forms only. Main custom bundles keep their own complete-item builder. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || form.closest('cart-drawer, cart-items, product-form') || (form.getAttribute('id') || '').indexOf('d4-form-') === 0) return;
    if (!form.querySelector('input[name="id"]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var button = form.querySelector('[type="submit"]');
    if (C.busy || form.dataset.d4AddAttempted === 'true' || (button && button.disabled)) return;
    var data = new FormData(form), item = { id: data.get('id'), quantity: Number(data.get('quantity') || 1), properties: {} };
    data.forEach(function (value, key) { var m = /^properties\[(.+)\]$/.exec(key); if (m) item.properties[m[1]] = value; });
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    if (button) button.disabled = true;
    form.dataset.d4CheckoutPending = 'true';
    C.add({ items: [item] }, { physical: !!form.querySelector('.dl3-offers'), bundleQuantity: item.quantity }).catch(function (err) {
      form.dataset.d4CheckoutPending = 'false';
      form.dataset.d4AddAttempted = String(!!err.addAttempted);
      if (button && !err.addAttempted) button.disabled = false;
      var alert = form.querySelector('[data-d4-checkout-error]');
      if (!alert) { alert = document.createElement('p'); alert.dataset.d4CheckoutError = ''; alert.setAttribute('role', 'alert'); form.appendChild(alert); }
      alert.textContent = err.message + ' Please review your bag before trying again. ';
      var link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'Review bag'; alert.appendChild(link);
    });
  }, true);

  /* Mark actual checkout departure, not the new product-to-cart navigation. */
  function markCheckout() { try { sessionStorage.setItem(marker, String(Date.now())); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var control = e.target.closest && e.target.closest('a[href], button, input[type="submit"]');
    if (!control || control.disabled) return;
    var href = control.getAttribute('href') || '';
    if (control.name === 'checkout' || /(?:^|\/)checkout(?:[?#]|$)/.test(href)) markCheckout();
  }, true);
  document.addEventListener('submit', function (e) {
    var button = e.submitter, action = e.target.getAttribute && e.target.getAttribute('action') || '';
    if ((button && button.name === 'checkout') || /(?:^|\/)checkout(?:[?#]|$)/.test(action)) markCheckout();
  }, true);

  /* Browser Back, including bfcache: refresh the real count; never add, clear or trap navigation. */
  function fallbackBag() {
    document.querySelectorAll('#cart-icon-bubble, .header__icon--cart, [data-d4-cart]').forEach(function (bag) {
      bag.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); window.location.assign(root + 'cart'); }, { capture: true, once: true });
    });
  }
  function refreshBag() {
    var returned = false;
    try { returned = !!sessionStorage.getItem(marker); sessionStorage.removeItem(marker); } catch (e) {}
    var refreshNeeded = returned || !!document.querySelector('form[data-d4-checkout-pending="true"], [data-d4-atc].is-loading');
    C.busy = false;
    if (window.D4Gift) window.D4Gift.checkoutPending = false;
    if (refreshNeeded) document.querySelectorAll('form[data-d4-checkout-pending="true"]').forEach(function (form) { form.dataset.d4CheckoutPending = 'false'; var button = form.querySelector('[type="submit"]'); if (button) button.disabled = false; });
    document.querySelectorAll('[data-d4-atc].is-loading').forEach(function (button) { button.disabled = false; button.classList.remove('is-loading'); });
    request('cart.js').then(function (cart) {
      var drawer = document.querySelector('cart-drawer');
      var refreshed = refreshNeeded && drawer && drawer.renderContents ? window.fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('Bag refresh failed'); return r.json(); }).then(function (sections) {
        if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('Bag refresh incomplete');
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        C.renderDrawer(sections);
      }).catch(function () {
        /* A stale drawer must not hide newly added items. Fall back to the current full bag. */
        fallbackBag();
      }) : Promise.resolve();
      return refreshed.then(function () {
      document.querySelectorAll('#cart-icon-bubble, .header__icon--cart, [data-d4-cart]').forEach(function (bag) {
        bag.setAttribute('aria-label', 'Shopping bag, ' + cart.item_count + ' items. Review or edit your bag');
        var badge = bag.querySelector('.cart-count-bubble');
        if (!badge && cart.item_count > 0) { badge = document.createElement('span'); badge.className = 'cart-count-bubble'; bag.appendChild(badge); }
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; badge.setAttribute('aria-hidden', 'true'); }
        if (returned && cart.item_count > 0) { bag.classList.remove('d4-bag-return'); void bag.offsetWidth; bag.classList.add('d4-bag-return'); setTimeout(function () { bag.classList.remove('d4-bag-return'); }, 4800); }
      });
      });
    }).catch(function () { if (refreshNeeded) fallbackBag(); });
  }
  var style = document.createElement('style');
  style.textContent = '@keyframes d4-bag-pulse{0%,100%{box-shadow:0 0 0 0 rgba(166,125,65,0);background-color:transparent}50%{box-shadow:0 0 0 6px rgba(166,125,65,.16);background-color:rgba(166,125,65,.12)}}.d4-bag-return{border-radius:50%;animation:d4-bag-pulse 1.6s ease-in-out 3}@media(prefers-reduced-motion:reduce){.d4-bag-return{animation:none;outline:2px solid currentColor;outline-offset:3px}}';
  document.head.appendChild(style);
  window.addEventListener('pageshow', refreshBag);
})();
